import React, { useState, useMemo, useCallback } from "react";
import WidgetConfigurationContext from "data-lake/preview/contexts/WidgetConfigurationContext";
import createInitialWidget from "data-lake/preview/storage-types/external/createInitialWidget";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
const WidgetConfigurationProvider = ({ initialSearch, children = null }) => {
  const [widget, setWidget] = useState(() => createInitialWidget(initialSearch));
  const { isLoading, isPending } = useFieldTypes();
  const resetWidget = useCallback(() => {
    setWidget(createInitialWidget());
  }, []);
  const contextValue = useMemo(
    () => ({
      widget,
      setWidget,
      isLoading: isLoading || isPending,
      resetWidget
    }),
    [isPending, isLoading, resetWidget, widget]
  );
  return /* @__PURE__ */ React.createElement(WidgetConfigurationContext.Provider, { value: contextValue }, children);
};
export default WidgetConfigurationProvider;
